export default "__VITE_PUBLIC_ASSET__530dd3bb__"